import api from "../../config/api";

const state = {
    activityDetails: null,
    loading: false,
    error: null,
    skillPersons: [], // 👈 For getskillpersonsjson
};

const mutations = {
    SET_ACTIVITY_DETAILS(state, payload) {
        state.activityDetails = payload;
    },
    SET_LOADING(state, payload) {
        state.loading = payload;
    },
    SET_ERROR(state, payload) {
        state.error = payload;
    },
    SET_SKILL_PERSONS(state, payload) {
        state.skillPersons = payload;
    },
};

const actions = {
    // 🔹 GET /activities/:id
    async fetchActivityDetails({ commit }, activityId) {
        if (activityId == null || activityId === "" || activityId === "undefined") {
            commit("SET_ERROR", "Activity ID is required");
            return null;
        }
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.get(`/activities/${activityId}`);
            commit("SET_ACTIVITY_DETAILS", response.data.output);
            return response.data.output;
        } catch (error) {
            commit(
                "SET_ERROR",
                error.response?.data?.message || "Failed to fetch activity details"
            );
            throw error;
        } finally {
            commit("SET_LOADING", false);
        }
    },

    // 🔹 PUT /activities/:id
    async updateActivityDetails({ commit }, { id, payload }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.put(`/activities/${id}`, payload);
            commit("SET_ACTIVITY_DETAILS", response.data.output);
            return response.data;
        } catch (error) {
            commit(
                "SET_ERROR",
                error.response?.data?.message || "Failed to update activity details"
            );
            throw error;
        } finally {
            commit("SET_LOADING", false);
        }
    },

    // workgroup store apis
    
    // 🔹 POST /manageskillajax (getskillpersonsjson)
    async fetchSkillPersons({ commit }, { skillid, locationid }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const requestBody = {
                cmd: "getskillpersonsjson",
                skillid,
                locationid,
            };

            const response = await api.post("/manageskillajax", requestBody);

            const personWithSkills =
                response?.data?.persons_with_skill?.map((p) => ({
                    personid: p.personid,
                    fullname: `${p.firstname} ${p.lastname}`,
                    email: p.email,
                    skilllevel: p.skilllevel ?? "-",
                })) || [];

            commit("SET_SKILL_PERSONS", personWithSkills);

            return personWithSkills;
        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                "Failed to fetch skill persons";
            commit("SET_ERROR", message);
            throw message;
        } finally {
            commit("SET_LOADING", false);
        }
    },

    // 🔹 POST /manageactivityajax (deleteworkgroup)
    async deleteWorkgroup(_, { locationid, workgroupid }) {
        try {
            const requestBody = {
                cmd: "deleteworkgroup",
                locationid,
                workgroupid,
                workgrouptype: "activity",
            };
            const response = await api.post("/manageactivityajax/", requestBody);
            return response.data;
        } catch (error) {
            throw (
                error.response?.data?.message ||
                error.response?.data?.error ||
                "Failed to delete workgroup"
            );
        }
    },
};

const getters = {
    activityDetails: (state) => state.activityDetails,
    activityDetailsLoading: (state) => state.loading,
    activityDetailsError: (state) => state.error,
    skillPersons: (state) => state.skillPersons,
};

export default {
    state,
    mutations,
    actions,
    getters,
};